module.exports = __webpack_public_path__ + "static/media/fi-sr-credit-card.3186e0af.svg";